import styled, {css} from 'styled-components';

import Button from '../Button';
import BaseDropdown from '../Dropdown';
import {mixins} from '../styles';
import BaseSmileIcon from './icons/smile.svg';

const EMOJI_WIDTH = 34;

const EMOJI_FONT_SOURCE =
  'https://gitcdn.xyz/repo/googlefonts/noto-emoji/master/fonts/NotoColorEmoji.ttf';

export const fontFace = css`
  @font-face {
    font-family: 'Noto Color Emoji';
    src: url(${EMOJI_FONT_SOURCE});
  }
`;

export const Dropdown = styled(BaseDropdown)`
  margin-right: ${({theme}) => theme.spacing.s3};
`;

type THeadButtonProps = {
  isActive?: boolean;
};

export const HeadButton = styled(Button).attrs({square: true})<THeadButtonProps>`
  width: ${EMOJI_WIDTH}px;
  border: none;
  border-radius: 100%;
  background: transparent;
  ${({isActive, theme: {branding}}) => css`
    color: ${isActive ? branding.content.primary : branding.content.secondary};
  `}
`;

export const Icon = styled.div`
  ${mixins.wh('18px')}
`;

export const SmileIcon = styled(BaseSmileIcon)`
  ${mixins.wh('18px')}
`;

export const EmojiPicker = styled.div<{unbounded: boolean}>`
  width: ${EMOJI_WIDTH * 10 + 32}px;
  overflow: hidden;

  ${({unbounded}) =>
    unbounded &&
    css`
      width: 100%;
    `}
`;

export const DropdownHeader = styled.div`
  display: flex;
  outline: none;
`;

export const Header = styled.div`
  ${({theme}) => css`
    ${mixins.flexAlign('space-around', 'center')}
    position: relative;
    margin: 0 ${theme.spacing.s4};
    padding: ${theme.spacing.s1} 0;
    border-bottom: 1px solid ${theme.palette.grey100};
    ${HeadButton} {
      box-shadow: none;
    }
  `}
`;

type THeaderPointerProps = {
  position: number;
  counter: number;
};

export const HeaderPointer = styled.div<THeaderPointerProps>`
  ${({theme, position, counter}) => css`
    ${mixins.position({position: 'absolute', left: 0, bottom: 0})}
    width: calc(100% / ${counter});
    height: 2px;
    background-color: ${theme.branding.content.primary};
    transform: translateX(${100 * position}%);
    transition: transform ${theme.animation.duration}ms linear;
  `}
`;

export const Search = styled.div`
  position: relative;
  padding: ${({theme}) => `${theme.spacing.s3} ${theme.spacing.s5}`};
`;

export const Content = styled.div`
  height: 270px;
  padding: ${({theme}) => `0 0 ${theme.spacing.s2} ${theme.spacing.s4}`};
  overflow-y: auto;
`;

export const GroupName = styled.div`
  ${mixins.f4}
  font-weight: 500;
  ${mixins.position({position: 'sticky', top: '-1px'})}
  width: 100%;
  ${({theme: {spacing, palette}}) => css`
    padding: ${`0 ${spacing.s2} ${spacing.s2}`};
    background-color: ${palette.white};
  `}
`;

export const Symbols = styled.div`
  display: flex;
  flex-flow: row wrap;
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: 'Noto Color Emoji', inherit;
`;

export const Char = styled.button.attrs({type: 'button'})`
  ${mixins.f6}
  ${mixins.wh(`${EMOJI_WIDTH}px`)}
  ${mixins.flexAlign('center')}
  padding: 0;
  border: 0;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  border-radius: 50%;
  ${({theme: {palette, branding}}) => css`
    &:hover {
      background-color: ${palette.grey300};
    }
    &:active {
      background-color: ${branding.backgrounds.secondary};
    }
  `}
`;

export const Secondary = styled.div`
  ${({theme}) => css`
    color: ${theme.branding.content.secondary};
    padding: ${theme.spacing.s2};
  `}
`;
